// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bft_a"};